import {
  IconBook,
  IconBulb,
  IconChartBar,
  IconCube,
  IconDatabase,
  IconGitBranch,
  IconInbox,
  IconLayoutDashboard,
  IconListSearch,
  IconMessageChatbot,
  // TODO: re-enable when Runbooks ships.
  // IconNotebook,
  IconRobot,
  IconScale,
  IconSchool,
  IconSearch,
  IconServer,
  IconSparkles,
  IconTerminal2,
} from '@tabler/icons-react'

export interface NavItem {
  name: string
  href: string
  icon: React.ComponentType<{ size?: number | string; color?: string }>
  /** When true the page requires Databricks workspace access and is hidden
   *  from users who are not on the SSO allowlist. */
  requiresDatabricks?: boolean
}

// The Genie Conversation API implementation of Chat with Data is retained
// behind a flag while the embedded Genie Agent experience is evaluated. Its
// route stays registered either way, so the page remains reachable by URL
// even when it is hidden from the sidebar and command palette.
export const legacyGenieChatEnabled =
  (import.meta.env.VITE_ENABLE_LEGACY_GENIE_CHAT as string | undefined) ===
  'true'

const legacyGenieChatNavItem: NavItem = {
  name: 'Chat with Data (API)',
  href: '/genie',
  icon: IconMessageChatbot,
  requiresDatabricks: true,
}

// Single source of truth for the app's primary navigation -- shared by the
// Sidebar and the GlobalSearch command palette so the two can never drift
// out of sync with each other.
export const primaryNavigation: NavItem[] = [
  { name: 'Dashboard', href: '/dashboard', icon: IconLayoutDashboard },
  {
    name: 'Chat with Data (Genie)',
    href: '/genie/embedded',
    icon: IconSparkles,
    requiresDatabricks: true,
  },
  ...(legacyGenieChatEnabled ? [legacyGenieChatNavItem] : []),
  { name: 'Data Catalog', href: '/data-catalog', icon: IconListSearch, requiresDatabricks: true },
  { name: 'Query Data', href: '/query', icon: IconTerminal2, requiresDatabricks: true },
  { name: 'Data Lineage', href: '/intelligence/lineage', icon: IconGitBranch, requiresDatabricks: true },
  {
    name: 'Legacy Data Lineage',
    href: '/sql-server-lineage',
    icon: IconServer,
  },
  {
    name: 'Data Governance',
    href: '/intelligence/governance',
    icon: IconScale,
  },
  { name: 'Requests', href: '/requests', icon: IconInbox },
  { name: 'Learning', href: '/learning', icon: IconSchool },
  // TODO: re-enable when Runbooks ships.
  // { name: 'Runbooks', href: '/runbooks', icon: IconNotebook },
]

export const comingSoonNavigation: NavItem[] = [
  { name: 'Job Analytics', href: '/analytics', icon: IconChartBar },
  { name: 'Documentation', href: '/documentation', icon: IconBook },
  { name: 'Data Assets', href: '/intelligence/assets', icon: IconDatabase },
  { name: 'Models', href: '/intelligence/models', icon: IconCube },
  {
    name: 'AI & Automation',
    href: '/intelligence/automation',
    icon: IconRobot,
  },
  { name: 'Insights', href: '/intelligence/insights', icon: IconBulb },
  { name: 'Ask Prism', href: '/intelligence/search', icon: IconSearch },
]
